export enum MM07MovementVelocity {
    SLOW = 'SLOW',
    FAST = 'FAST'
}
